import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-white py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-100" data-id="element-44">
      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center text-center" data-id="element-45">
        <img src="https://cdn.magicpatterns.com/uploads/mPSWxYNkSeVkHGPmx5fC8y/transparente-10.png" alt="Centro Formativo Cumbre" className="h-10 object-contain mb-6 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all" data-id="element-46" />
        <p className="text-brand-black font-heading font-bold text-lg mb-2" data-id="element-47">
          Centro Formativo Cumbre
        </p>
        <p className="text-gray-500 text-sm" data-id="element-48">
          &copy; {currentYear} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}